<template>
  <div>
    <ApplicationInformationSection
      :onValueChanged="onValueChanged"
      :submissionDate="application.submissionDate"
    />
    <ApplicationForm
      :application="application"
      :onValueChanged="onValueChanged"
      :addAdditionalSectionThree="addAdditionalSectionThree"
      :removeSectionThree="removeSectionThree"
      :addAdditionalSectionFour="addAdditionalSectionFour"
      :removeSectionFour="removeSectionFour"
      :allowImages="false"
      :emailDisclaimerShown="true"
      :showEmailDisclaimer="showEmailDisclaimer"
    />
  </div>
</template>

<script>
import ApplicationForm from "@/components/Application/Form";
import ApplicationInformationSection from "@/components/Speaker/ApplicationInformationSection";
import { Application } from "@/typings/application";

export default {
  components: {
    ApplicationForm,
    ApplicationInformationSection
  },
  props: {
    application: {
      type: Application,
      required: true,
      default: () => {
        return new Application();
      }
    },
    onValueChanged: {
      type: Function,
      required: true,
      default: () => {}
    },
    addAdditionalSectionThree: {
      type: Function,
      required: true,
      default: () => {}
    },
    removeSectionThree: {
      type: Function,
      required: true,
      default: () => {}
    },
    addAdditionalSectionFour: {
      type: Function,
      required: true,
      default: () => {}
    },
    removeSectionFour: {
      type: Function,
      required: true,
      default: () => {}
    },
    showEmailDisclaimer: {
      type: Function,
      required: true,
      default: () => {}
    }
  }
};
</script>
